import React, { useEffect, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Header, Footer } from "@containers";
import { UseNetworkStatus } from "@utils";
import { getBGimage, getCountDown } from "@store";
import routes from "./route";
import "./App.css";

import { getSelectedPlayerData } from "@store";

const NotFound = lazy(() => import("@components/notFound"));

function App() {
  const dispatch = useDispatch();
  const { isOnline } = UseNetworkStatus();
  const bgImage = useSelector((state) => state.setting.bgImage);
  const isImg = bgImage?.data?.data?.attributes?.bgImage?.data?.attributes?.url;

  useEffect(() => {
    dispatch(getBGimage());
    dispatch(getCountDown());

  }, []);

  useEffect(() => {
    const checkCartExpiration = () => {
      const lastUpdated = parseInt(localStorage.getItem('CartTimer'));
      const now = new Date().getTime();
      if (lastUpdated && (now - lastUpdated > 30 * 60 * 1000)) {
        localStorage.removeItem('LocalCartData');
        localStorage.removeItem('CartTimer');
        dispatch(getSelectedPlayerData({ save: false }))
      }
    };
    checkCartExpiration();
    const interval = setInterval(checkCartExpiration, 60 * 1000);
    return () => clearInterval(interval);
  }, [])

  return (
    <div
      style={{
        backgroundImage: `url(${isImg})`,
      }}
      className="background-Img"
    >
      <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "start",
          margin: "auto",
          width: "full",
          height: "full",
          backgroundColor: "rgba(18,16,55,0.50)",
        }}
      >
        {isOnline ? (
          <React.Fragment>
            <div
              style={{
                width: "100%",
                maxWidth: "1600px",
                height: "auto",
                minHeight: "100vh",
              }}
            >
              <Routes>
                {routes.map((item, index) => (
                  <Route
                    key={"" + index}
                    exact={item.exact}
                    isPublic={item.isPublic}
                    path={item.path}
                    name={item.name}
                    element={
                      <>
                        <Header />
                        <div
                          style={{
                            minHeight: window.innerHeight * 0.67,
                            maxWidth: "1500px",
                            width: "100%",
                            margin: "auto",
                          }}
                        >
                          {item.element}
                        </div>
                        <Footer />
                      </>
                    }
                  />
                ))}
                <Route
                  exact={true}
                  isPublic={true}
                  path={"*"}
                  name={"NotFound"}
                  element={<NotFound />}
                />
              </Routes>
            </div>
          </React.Fragment>
        ) : (
          <div
            style={{
              width: "100%",
              height: "200px",
              display: "flex",
              margin: "auto",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-around",
              backgroundColor: "white",
            }}
          >
            <div>
              <h1
                style={{
                  marginTop: "50px",
                  color: "gray",
                  fontWeight: "bold",
                  fontSize: "20px",
                }}
              >
                Welcome To The K Club{" "}
              </h1>
            </div>
            <div
              style={{
                marginTop: "50px",
                color: "green",
                fontWeight: "bold",
                fontSize: "30px",
              }}
            >
              <h1 className="animate-pulse ">Your Are Offline </h1>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
